import http from "../../axios-config/g-http-metodos";

function getUsuarios(pesquisaEscrita){
    const{ res, erro, requisicao} = http.get(`Usuario/GetUsuarios/${pesquisaEscrita}`)
    return{Usuario: res , erro, requisicao}
}

function GetAllById(usuarioId){
    const{ res, erro, requisicao} = http.get(`Usuario/GetAllById/${usuarioId}`)
    return{Usuario: res , erro, requisicao}
} 

function getUsuariosLogados(UsuarioLogadoFiltro){
    const{ res, erro, requisicao} = http.postArray("Usuario/GetUsuariosLogados", UsuarioLogadoFiltro)
    return{Usuario: res , erro, requisicao}
}

function Logout(UsuarioId) {
    const{ res, erro, requisicao} = http.post(`Usuario/Logout/${UsuarioId}`);
    return{ Usuario: res , erro, requisicao}
}
function PostUsuario(){
    const{ res, erro, requisicao} = http.post(`Usuario/PostUsuario`)
    return{ Usuario: res , erro, requisicao}
}

function ExcluirUsuario(UsuarioId){
    const { res, erro, requisicao } = http.post(`Usuario/ExcluirUsuario/${UsuarioId}`);
    return { UsuarioId: res, erro, requisicao }
}


function GetCodigoExternoByUsuarioLogado(){
    const{ res, erro, requisicao} = http.get(`GetCodigoExternoByUsuarioLogado`)
    return{Usuario: res , erro, requisicao}
} 


const UsuarioController = {
    Logout,
    getUsuariosLogados,
    getUsuarios,
    ExcluirUsuario,
    PostUsuario,
    GetAllById,
    GetCodigoExternoByUsuarioLogado
  }

  export default UsuarioController
